class CommonHelper {

    isEmpty = (value) => {
        if (value === null || value === undefined) return true;

        if (typeof value === 'string') return value.trim() === "";

        if (typeof value === 'boolean') return false;

        if (typeof value === 'number') return isNaN(value);

        if (typeof value === 'function') return false;

        if (typeof value === 'symbol' || typeof value === 'bigint') return false;

        if (Array.isArray(value)) return value.length === 0;

        if (typeof value === 'object') {
            // For plain objects and Dates
            if (value instanceof Date) return isNaN(value.getTime());
            return Object.keys(value).length === 0;
        }
        return false;
    };


    buildHierarchy = (flatList, parentId = null) => {
        return flatList
            .filter(item => item.parentId === parentId)
            .sort((a, b) => a.sequence - b.sequence)
            .map(item => {
                const children = this.buildHierarchy(flatList, item.moduleId);
                return {
                    ...item,
                    ChildList: children.length > 0 ? children : undefined
                };
            });
    }
}

const commonHelper = new CommonHelper();
export default commonHelper;
